import { render, staticRenderFns } from "./klgItem.vue?vue&type=template&id=52f5c567&scoped=true&"
import script from "./klgItem.vue?vue&type=script&lang=js&"
export * from "./klgItem.vue?vue&type=script&lang=js&"
import style0 from "./klgItem.vue?vue&type=style&index=0&id=52f5c567&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f5c567",
  null
  
)

export default component.exports